import * as Cookies from '../utils/cookies';
import axios from 'axios';

export async function getLeagueInfo(league_pk) {
  const token = Cookies.getToken();

  const res = await axios({
    method: 'GET',
    url: process.env.REACT_APP_API_URL + `/api/league/leagues/${league_pk}`,
    headers: { Authorization: `Bearer ${token}` },
  });

  if (res.status === 200) {
    return res.data;
  } else {
    return { error: res.status };
  }
}
